module.exports = "../content/035a5a9cf30e57354b097a3a61348d38.woff2";